/* global Keycloak */
import { keycloakConfigOrigin } from './config';

// A simple wrapper around the Keycloak SDK that automatically refreshes the token every so
// often and provides an Authorization header for services that need to be authed.
const keycloakService = (() => {
  let keycloakToken = null;

  const keycloak = window.Keycloak
    ? new Keycloak(`${keycloakConfigOrigin}/keycloak/keycloak.json`)
    : null;

  return {
    keycloak,
    login: () => new Promise((resolve) => {
      keycloak.init({ onLoad: 'check-sso' }).then((isAuthenticated) => {
        if (isAuthenticated) {
          keycloakToken = keycloak.token;

          // The Keycloak tokens expire after 60 seconds, so we'll refresh them every 45.
          setInterval(() => {
            keycloak.updateToken(30).then(() => {
              keycloakToken = keycloak.token;
            });
          }, 45 * 1000);
        }

        resolve(isAuthenticated);
      });
    }),
    getToken: () => keycloakToken,
    getAuthHeader: () => (keycloakToken ? `Bearer ${keycloakToken}` : ''),
  };
})();
export default keycloakService;
